// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ReceiptPage.module.css */

.ReceiptPage_container__PLIOn {
  max-width: 800px;
  margin: 0 auto;
  padding: 24px;
  font-family: 'Inter', sans-serif;
}

.ReceiptPage_backBtn__yfjX4 {
  background: none;
  border: none;
  color: #4a90e2;
  cursor: pointer;
  margin-bottom: 16px;
  font-size: 1rem;
}
.ReceiptPage_backBtn__yfjX4:hover {
  text-decoration: underline;
}

.ReceiptPage_title__\\+BBD\\+ {
  font-size: 1.75rem;
  margin-bottom: 16px;
}

.ReceiptPage_meta__QLsWB p {
  margin: 4px 0;
  font-size: 0.95rem;
}

.ReceiptPage_statusBadge__5ibfV {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 500;
}

.ReceiptPage_statusClosed__zZP2t {
  background-color: #d4edda;
  color: #155724;
}

.ReceiptPage_statusOpen__Z4dAJ {
  background-color: rgb(0, 123, 255);
  color: #ffffff;
}

.ReceiptPage_subTitle__LdZuY {
  margin-top: 24px;
  font-size: 1.25rem;
}

.ReceiptPage_table__Dg86m {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
}

.ReceiptPage_table__Dg86m th,
.ReceiptPage_table__Dg86m td {
  border: 1px solid #eee;
  padding: 8px 12px;
  text-align: left;
}

.ReceiptPage_table__Dg86m th {
  background-color: #f9f9f9;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/ReceiptPage/ReceiptPage.module.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":["/* ReceiptPage.module.css */\r\n\r\n.container {\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n  padding: 24px;\r\n  font-family: 'Inter', sans-serif;\r\n}\r\n\r\n.backBtn {\r\n  background: none;\r\n  border: none;\r\n  color: #4a90e2;\r\n  cursor: pointer;\r\n  margin-bottom: 16px;\r\n  font-size: 1rem;\r\n}\r\n.backBtn:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.title {\r\n  font-size: 1.75rem;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.meta p {\r\n  margin: 4px 0;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.statusBadge {\r\n  display: inline-block;\r\n  padding: 2px 8px;\r\n  border-radius: 4px;\r\n  font-weight: 500;\r\n}\r\n\r\n.statusClosed {\r\n  background-color: #d4edda;\r\n  color: #155724;\r\n}\r\n\r\n.statusOpen {\r\n  background-color: rgb(0, 123, 255);\r\n  color: #ffffff;\r\n}\r\n\r\n.subTitle {\r\n  margin-top: 24px;\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 8px;\r\n}\r\n\r\n.table th,\r\n.table td {\r\n  border: 1px solid #eee;\r\n  padding: 8px 12px;\r\n  text-align: left;\r\n}\r\n\r\n.table th {\r\n  background-color: #f9f9f9;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ReceiptPage_container__PLIOn`,
	"backBtn": `ReceiptPage_backBtn__yfjX4`,
	"title": `ReceiptPage_title__+BBD+`,
	"meta": `ReceiptPage_meta__QLsWB`,
	"statusBadge": `ReceiptPage_statusBadge__5ibfV`,
	"statusClosed": `ReceiptPage_statusClosed__zZP2t`,
	"statusOpen": `ReceiptPage_statusOpen__Z4dAJ`,
	"subTitle": `ReceiptPage_subTitle__LdZuY`,
	"table": `ReceiptPage_table__Dg86m`
};
export default ___CSS_LOADER_EXPORT___;
